/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { PastTestResultsTabs } from './consts'
import * as classes from './styles'

const tabs = Object.values(PastTestResultsTabs).map((item) => ({ id: item, title: item }))

export const PastTestResults: FC = () => {
  const [activeTab, setActiveTab] = useState<TabsItem>(tabs[0])

  const renderTab = () => {
    const { title } = activeTab

    if (title === PastTestResultsTabs.DESCRIPTION) {
      return <DescriptionForm page={DescriptionPages.PastTestResults} />
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Past Test Results
      </Typography>

      <TabsNavigation<TabsItem> tabs={tabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}
